<template>
  <div class="moreinfo mb-5">
    <div class="moreinfo-overlay" @click="closeMoreInfo"></div>
    <div class="moreinfo-content" v-if="services !== ''">
      <div v-html="services"></div>
      <div @click="closeMoreInfo" class="moreinfo-close btn-delete">
        <span></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      services: ''
    }
  },
  name: "InclusiveServices",
  methods: {
    closeMoreInfo() {
      this.$emit('closeClicked', false);
    }
  },
  created() {
    var loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.loadingContainer,
        canCancel: true,
        onCancel: this.onCancelLoading,
        opacity: 0.7,
    });
    loader;

    this.axios
    .post(this.url +  "/index.php?id=487")
    .then((response) => {
      this.status = response.status;
      this.services = response.data;
      loader.hide();
    });
  }
}
</script>
